import { clientI18n } from '../../../shared/scripts/ClientI18n.ts';
import { createDivIn, setElementOnClick } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { uiManager } from '../EntryMobile.ts';
import { UIMFullscreenHeader } from '../ui_html/header/UIMFullscreenHeader.ts';
import { AudioManager, AudioType } from '@colonist/audio';
export class UIMFullscreenPageView {
    build(isBackButtonX = false) {
        // TODO: we should not call this build function. It makes the code more complex
        if (this.hasBeenBuilt) return this.scrollContentToTop();
        this.container = document.getElementById('fullscreen-page-container');
        this.page = createDivIn(this.container, 'fullscreen-page');
        if (this.showHeader) this.header = new UIMFullscreenHeader(this.page, this.title, isBackButtonX);
        var _this_bodyClass;
        this.body = createDivIn(this.page, (_this_bodyClass = this.bodyClass) !== null && _this_bodyClass !== void 0 ? _this_bodyClass : 'fullscreen-page-body');
        this.buildView();
        if (this.header) {
            setElementOnClick(this.header.backButton, ()=>{
                if (this.backButtonAction) {
                    AudioManager.play(AudioType.Click);
                    this.backButtonAction();
                }
                if (this.shouldHideOnBackButton) this.hide();
            });
        }
        this.hasBeenBuilt = true;
    }
    show() {
        this.page.style.display = 'flex';
        this.scrollContentToTop();
    }
    hide() {
        this.page.style.display = 'none';
    }
    updateHeader(title) {
        this.title = title;
        if (this.header) this.header.title.innerText = clientI18n.t(this.title.key, this.title.options);
    }
    removeFromDOM() {
        uiManager.adController.hideBannerAds();
        this.page.remove();
        this.hasBeenBuilt = false;
    }
    scrollContentToTop() {
        const contentSection = this.body.querySelector('.content_singleton_page');
        if (!contentSection) return;
        contentSection.scrollTop = 0;
    }
    constructor(title, pageId, backButtonAction, bodyClass, showHeader = true){
        this.hasBeenBuilt = false;
        this.shouldHideOnBackButton = true;
        this.title = title;
        this.pageId = pageId;
        this.backButtonAction = backButtonAction;
        this.showHeader = showHeader;
        this.bodyClass = bodyClass;
        uiManager.adController.hideAllAds();
    }
}
